import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHybridView1 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M15 5.25h-4.5v7.5H15zm-6-1.5v10.5h7.5V3.75zm-1.5 1.5h-6v-1.5h6zm0 3h-6v-1.5h6zm0 3h-6v-1.5h6zm0 3h-6v-1.5h6z",
		clipRule: "evenodd"
	})
});
export default SvgHybridView1;
